import React, { memo } from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { PieChartData } from './utils';
import { useLabelStyles } from './hooks/useLabelStyles';

type ProjectComponentProps = {
  data: PieChartData;
  loading: boolean;
  isEmpty: boolean;
  setGetCurrentPage?: React.Dispatch<React.SetStateAction<number>> | undefined;
};

export const ProjectComponent: React.FC<ProjectComponentProps> = ({
  data,
  loading,
  isEmpty,
  setGetCurrentPage
}: ProjectComponentProps) => {
  const classes = useLabelStyles();
  const name = useMessage('insights.timeSheetLabels.projects');

  return (
    <Paper
      elevation={3}
      data-testid={'source-by-project-chart-container'}
      className={classes.container}
      tabIndex={0}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="h6"
            data-testid="project-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart
              data={data}
              labelType="PROJECT"
              setGetCurrentPage={setGetCurrentPage}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(ProjectComponent);
